import { InjectionToken } from '@angular/core';

export const MAPS_BACKEND_URL = new InjectionToken<string>('mapsBackendUrl');
